const romanian = {
    'CRAFT.Type_Logistics' : 'Logistică { number }',
    'CRAFT.Type_Floor' : 'Pardoseală { number }',
    'CRAFT.Type_Assembly' : 'Montaj { number }',
    'CRAFT.Type_Electrics' : 'Electrice { number }',
    'CRAFT.Type_Graphic' : 'Grafică { number }',
    'CRAFT.Type_Furniture' : 'Mobilier { number }',
    'CRAFT.Type_Multimedia' : 'Multimedia { number }',
    'CRAFT.Type_Cleaning' : 'Curățenie { number }',
    'CRAFT.Type_Additional' : 'Suplimentar { number }',
    'CRAFT.Type_MPControl' : 'Control MP',
    'CRAFT.Type_Protocol' : 'Protocol',
    'CRAFT.Type_Service' : 'Service { number }',
    'CRAFT.Type_CollectGraphics' : 'Colectare grafică',
    'CRAFT.Status_Text_InProgress' : 'În curs',
    'CRAFT.Status_Text_Disabled' : 'Dezactivat',
    'CRAFT.Status_Text_Completed' : 'Finalizat',
    'CRAFT.Status_Text_Overdue' : 'Întârziat',
    'CRAFT.Status_Text_Done' : 'Colectat',
    'CRAFT.Status_Text_Open' : 'Deschis',
    'CRAFT.Status_Text_Collected': 'Colectat',
    'CRAFT.Status_Warning_Cannot_Change_Done': 'Nu se poate schimba statusul: grafica a fost deja procesată în panoul admin',
    'CRAFT.Button_ViewAll' : 'Vezi tot',
    'CRAFT.Button_Text_Print' : 'Tipărește',
    'CRAFT.Button_Text_Stand' : 'Stand',
    'CRAFT.Button_Text_MarkOpen' : 'Marchează lucrarea deschisă',
    'CRAFT.Button_Text_MarkDone' : 'Marchează lucrarea finalizată',
    'CRAFT.Button_Text_MarkInProgress' : 'Marchează lucrarea în curs',
    'CRAFT.Button_ChangeStatus_InProgress' : 'În curs',
    'CRAFT.Button_ChangeStatus_Done': 'Gata',
    'CRAFT.Button_Text_ShelfNumber' : 'Nr. raft',
    'CRAFT.Filter_Params_CraftType' : 'Lucrare: { withFilter }',
    'EXHIBITION.Select_Instruction' : 'Selectați o expoziție { br } din lista de mai jos',
    'EXHIBITION.Select_Label' : 'EXPOZIȚIE SELECTATĂ',
    'EXHIBITION.Modal_Title' : 'ALEGE EXPOZIȚIA',
    'EXHIBITION.Timer_State_Underway' : 'ÎN CURS',
    'EXHIBITION.Timer_State_Ended' : 'ÎNCHEIAT',
    'EXHIBITION.Title_CraftTotal' : 'Prezentare totală lucrări',
    'EXHIBITION.Statistic_Status_InTotal' : 'în total',
    'EXHIBITION.Statistic_Status_InProgress' : 'în curs',
    'EXHIBITION.Statistic_Status_Done' : 'gata',
    'EXHIBITION.Statistic_Status_Overdue' : 'întârziat',
    'EXHIBITION.Statistic_Status_NotApproved' : 'neaprobat',
    'EXHIBITION.Statistic_Type_Stands' : 'Standuri',
    'EXHIBITION.Statistic_Type_Claims' : 'Reclamații MP',
    'EXHIBITION.Statistic_Type_CustomerClaims' : 'Reclamații expozant',
    'EXHIBITION.Statistic_Type_LastMinute' : 'Last minute',
    'EXHIBITION.Statistic_Type_MpControl' : 'Control MP',
    'EXHIBITION.Statistic_Type_Damages' : 'Daune',
    'EXHIBITION.Statistic_Type_Protocol' : 'Protocol',
    'FORM.Textarea_Placeholder_JobDescription' : 'Descriere sarcină*',
    'FORM.Button_Text_AddJob' : 'Adaugă sarcină',
    'FORM.Button_Text_SaveJob' : 'Salvează sarcina',
    'FORM.Button_AddJobPhoto' : 'Adaugă fotografie',
    'FORM_RULES.Required_Login' : 'Introduceți loginul',
    'FORM_RULES.Required_Password' : 'Introduceți parola',
    'FORM_RULES.Required_KeyDescription' : 'Introduceți descrierea cheii',
    'FORM_RULES.Required_KeyNumber' : 'Introduceți numărul cheii',
    'FORM_RULES.Required_JobDescription' : 'Adăugați descrierea sarcinii',
    'FORM_RULES.Required_Quantity' : 'Introduceți cantitatea',
    'FORM_RULES.Min_Quantity' : 'Cantitatea trebuie să fie un număr de cel puțin unu',
    'FORMS.Input_Label_Login' : 'login',
    'FORMS.Input_Label_Password' : 'parolă',
    'FORMS.Button_Text_Login' : 'Autentificare',
    'FORMS.Input_Label_Description' : 'Descriere',
    'FORMS.Input_Label_KeyNumber' : 'Număr cheie',
    'FORMS.Input_Label_Hall' : 'Hală',
    'FORMS.Input_Label_Stands' : 'Standuri',
    'FORMS.Button_Text_ApplyFilters' : 'Aplică',
    'FORMS.Button_Text_ResetFilters' : 'Resetează filtrele',
    'FORMS.Select_DefaultValue_All' : 'Toate',
    'FORMS.Select_StandTypeValue_CraftInProgress' : 'Cu lucrări în curs',
    'FORMS.Select_StandTypeValue_CraftCompleted' : 'Cu lucrări finalizate',
    'FORMS.Select_StandTypeValue_ControlInProgress' : 'Cu controale în curs',
    'FORMS.Select_StandTypeValue_ProtocolInProgress' : 'Cu protocoale în curs',
    'FORMS.Select_StandTypeValue_OverdueCrafts' : 'Cu lucrări întârziate',
    'FORMS.Select_StandTypeValue_AdditionalJobs' : 'Cu sarcini suplimentare',
    'FORMS.Button_Text_ApplySort' : 'Aplică',
    'FORMS.Input_Label_CraftType' : 'Tip lucrare',
    'FORMS.Input_Label_JobType'   : 'Tip',
    'FORMS.Input_Label_JobFlag'   : 'Marcaj',
    'FORMS.Input_Label_JobStatus' : 'Status',
    'FORMS.Input_Label_CraftStatus' : 'Status lucrare',
    'FORMS.Input_Label_DamageStatus' : 'Status daune',
    'FORMS.Input_Label_Subcontractor' : 'Subcontractor',
    'FORMS.Input_Label_Comments' : 'Comentarii',
    'FORMS.Select_JobStatusValue_JobsOpen' : 'Sarcini deschise',
    'FORMS.Select_JobStatusValue_JobsInProgress' : 'Sarcini în curs',
    'FORMS.Select_JobStatusValue_FinishedJobs' : 'Sarcini finalizate',
    'FORMS.Select_JobFlag_WithoutFlag' : 'Fără marcaj',
    'FORMS.Select_JobFlag_WithFlag' : 'Cu marcaj',
    'FORMS.Input_Label_FurnishingName' : 'Nume mobilier',
    'FORMS.Input_Label_FurnishingReturnQuantity' : 'Cantitate',
    'FORMS.Input_Label_Quantity' : 'Cantitate',
    'FORMS.Input_Label_CurrentQuantity' : 'Cantitate curentă',
    'FORMS.Input_Label_NewQuantity' : 'Cantitate nouă',
    'FORMS.RadioInput_Text_Description' : 'Descriere',
    'FORMS.RadioInput_Text_Furnishing' : 'Mobilier',
    'FORMS.RadioInput_Text_FurnishingClaim' : 'Mobilier',
    'FORMS.Input_Label_OrderType'   : 'Tip',
    'FORMS.Select_FurnishingOrder_Type_Return' : "Retur articol",
    'FORMS.Select_FurnishingOrder_Type_Lost' : "Pierdut",
    'FORMS.Select_FurnishingOrder_Type_Correction' : "Modifică totalul",
    'FORMS.Select_FurnishingOrder_Type_Order' : "Comandă",
    'GLOBAL.Button_Text_Logout' : 'Deconectare',
    'GLOBAL.Button_Text_Filter' : 'Filtru',
    'GLOBAL.Button_Text_Sort' : 'Sortare',
    'GLOBAL.Text_Version' : 'Versiune { versionNumber }',
    'GLOBAL.Button_Text_Cancel' : 'Anulează',
    'GLOBAL.Badge_Text_New' : 'NOU',
    'GLOBAL.Modal_Title_Filters' : 'Filtre',
    'GLOBAL.Modal_Title_SortBy' : 'Sortare după',
    'GLOBAL.TimeLeft' : 'mai rămâne { timeLeft }',
    'GLOBAL.Text_Piece' : 'buc.',
    'GLOBAL.Button_Text_Confirm' : 'Confirmă',
    'GLOBAL.Language_Default' : 'Implicit',
    'TRANSLATION.Button_Text_TranslateInput' : 'Tradu în germană',
    'TRANSLATION.Button_Text_TranslateNative' : 'Tradu în limba mea',
    'TRANSLATION.Button_Text_ShowOriginal' : 'Afișează germana originală',
    'TRANSLATION.Text_InputTranslating' : 'Se traduce...',
    'TRANSLATION.Text_InputTranslated' : 'Tradus',
    'TRANSLATION.Text_InputTranslationError' : 'Traducerea a eșuat',
    'TRANSLATION.Text_InputTranslationRequired' : 'Vă rugăm să traduceți textul înainte de trimitere',
    'TRANSLATION.Text_ApiUnavailable' : 'Traducerea nu este disponibilă momentan',
    'GLOBAL.Card_Hero_Hall' : 'Hală',
    'GLOBAL.Card_Hero_Block' : 'Bloc',
    'GLOBAL.Card_Hero_Stand' : 'Stand',
    'GLOBAL.Comment': 'Comentariu',
    'HALL.Button_Text_HallPlan' : 'Plan hală',
    'HALL.Link_Text_HallPlan' : 'Plan hală { hallName }',
    'JOB.Tag_Claim' : 'C',
    'JOB.Tag_CustomerClaim' : 'C',
    'JOB.Tag_MPAndCustomerClaim' : 'C',
    'JOB.Tag_LastMinute' : 'LM',
    'JOB.Tag_Damage' : 'D',
    'JOB.Tag_ProtocolDefect' : 'PD',
    'JOB.Card_Hero_Hall' : 'Hală',
    'JOB.Card_Hero_Number' : 'Nr. sarcină',
    'JOB.Card_Hero_Block' : 'Bloc',
    'JOB.Card_Hero_Stand' : 'Stand',
    'JOB.Card_Hero_Exhibitor' : 'Expozant',
    'JOB.Button_Text_ToTheStand' : 'La stand',
    'JOB.Text_Creator' : 'de { whoCreate } la { whenCreate }',
    'JOB.Text_InWork' : 'de { whoWork } la { whenWork }',
    'JOB.Text_Executor' : 'de { whoExecute } la { whenExecute }',
    'JOB.Text_DurationTime' : 'Durată: { time }',
    'JOB.Type_Claim' : 'Reclamație MP',
    'JOB.Type_AllClaims' : 'Reclamație',
    'JOB.Type_CustomerClaim' : 'Reclamație expozant',
    'JOB.Type_LastMinute' : 'Last minute',
    'JOB.Type_Damage' : 'Daună',
    'JOB.Type_ProtocolDefect' : 'Defect protocol',
    'JOB.Button_ChangeStatus_Waiting' : 'Preia sarcina',
    'JOB.Button_ChangeStatus_InProgress' : 'Sarcină în curs',
    'JOB.Button_ChangeStatus_Done' : 'Finalizează sarcina',
    'JOB.Modal_Title_Photo' : 'Fotografie sarcină',
    'JOB.Filter_Params_JobType' : 'Tip: { withFilter }',
    'JOB.Filter_Params_CraftType' : 'Lucrare: { withFilter }',
    'JOB.Modal_Title_NewJob' : 'Nou { jobType }',
    'JOB.Modal_Title_EditJob' : 'Editează { jobType }',
    'JOB.Button_Text_AddClaim' : 'Adaugă reclamație MP',
    'JOB.Button_Text_AddCustomerClaim' : 'Adaugă reclamație expozant',
    'JOB.Button_Text_AddLastMinute' : 'Adaugă sarcină last minute',
    'JOB.Button_Text_AddDamage' : 'Adaugă fotografie daună',
    'JOB.Button_Text_AddProtocolDefect' : 'Adaugă defect protocol',
    'DAMAGE.Card_Title' : 'Daune ale { exhibitor }',
    'DAMAGE.Modal_Title_Photo' : 'Daune { exhibitor }',
    'DAMAGE.Status_Label_New' : 'Neverificat',
    'DAMAGE.Status_Label_Check' : 'Verificat',
    'DAMAGE.Status_Label_DCheck' : 'Aprobat',
    'DAMAGE.Button_Text_Stand' : 'Stand',
    'DAMAGE.Button_Text_Photo' : 'Foto',
    'DAMAGE.Button_Text_AddNote' : "ADAUGĂ NOTĂ",
    'DAMAGE.Modal_Button_AddPhoto' : 'Adaugă fotografie',
    'DAMAGE.Modal_Button_CreateReport' : 'Creează raport',
    'DAMAGE.Modal_Button_EditReport' : 'Editează raport',
    'DAMAGE.AsCraft_label' : "Daune",
    "DAMAGE.Button_Text_Open" : "Deschide",
    "STAND.Block_Title_Damages" : "Daune",
    'MENUS.Label_Overview' : 'Prezentare',
    'MENUS.Label_Stands' : 'Standuri',
    'MENUS.Label_Jobs' : 'Sarcini',
    'MENUS.Label_ExpoPlan' : 'Plan expo',
    'MENUS.Label_More' : 'Mai mult',
    'MENUS.Label_SelectExhibition' : 'Selectează expoziția',
    'MENUS.Label_CraftsOverview' : 'Prezentare lucrări',
    'MENUS.Label_HallsOverview' : 'Prezentare hale',
    'MENUS.Label_ViewDamages' : 'Vezi daune',
    'MENUS.Label_Downloads' : 'Descărcări',
    'MENUS.Label_Documents' : 'Documente',
    'MENUS.Label_FurnishingLeftovers' : 'Resturi mobilier',
    'MENUS.Label_HelpImprint' : 'Imprint',
    'MENUS.Label_CollectGraphics' : 'Colectare grafică',
    'NO_DATA.Exhibitions' : 'Nu aveți încă nicio expoziție.',
    'NO_DATA.Documents' : 'Expoziția curentă nu are { br } încă documente.',
    'NO_DATA.Stands' : 'Nu au fost găsite standuri { br } pentru căutare',
    'NO_DATA.StandPhoto' : 'Nu aveți încă fotografie de stand',
    'NO_DATA.DamagePhoto' : 'Nu aveți încă fotografie cu daunele { br } acestui stand',
    'NO_DATA.Stand_NoKeys' : 'Acest stand nu are încă chei',
    'NO_DATA.Stand_DoesNotExist' : 'Acest stand nu există',
    'NO_DATA.Subcontractor_Unsigned' : 'Nesemnat',
    'NO_DATA.Jobs' : 'Nu au fost găsite sarcini { br } pentru căutare',
    'NO_DATA.Damages' : 'Nu au fost găsite daune { br } pentru căutare',
    'NO_DATA.Hall' : 'Această hală nu există',
    'NO_DATA.HallPlan' : 'Nu am găsit un plan al acestei hale',
    'NO_DATA.Furnishing_Storage' : 'Această expoziție nu are { br } mobilier în stoc',
    'NO_DATA.Furnishing_Orders' : 'Această expoziție nu are { br } comenzi de mobilier',
    'PAGE.Title_Overview' : 'Prezentare',
    'PAGE.Title_ExhibitionSelection' : 'Selectare expoziție',
    'PAGE.Title_Stands' : 'Standuri',
    'PAGE.Title_Stand' : 'Stand',
    'PAGE.Title_StandComments' : 'Comentarii stand',
    'PAGE.Title_StandLog' : 'Jurnal stand',
    'PAGE.Title_StandKeys' : 'Chei stand',
    'PAGE.Title_ViewDamages' : 'Vezi daune',
    'PAGE.Title_AdditionalMenu' : 'Meniu suplimentar',
    'PAGE.Title_Jobs' : 'Sarcini',
    'PAGE.Title_ExpoPlan' : 'Plan expo',
    'PAGE.Title_Documents' : 'Documente',
    'PAGE.Title_FurnishingLeftovers' : 'Mobilier LM',
    'PAGE.Title_FurnishingReturns' : 'Jurnal modificări mobilier',
    'PAGE.Title_HallPlan' : 'Plan hală',
    'PAGE.Title_HallsOverview' : 'Prezentare hale',
    'PAGE.Title_CraftsOverview' : 'Prezentare lucrări',
    'PAGE.Title_HelpImprint' : 'Imprint',
    'PAGE.Title_CollectGraphics' : 'Colectare grafică',
    'SORT.Text_NewestByCreation' : 'Cele mai noi după data creării',
    'SORT.Text_OldestByCreation' : 'Cele mai vechi după data creării',
    'SORT.Text_ExhibitorNameAZ' : 'Nume expozant (A-Z)',
    'SORT.Text_ExhibitorNameZA' : 'Nume expozant (Z-A)',
    'SORT.Text_FinishedFirst' : 'Finalizate primele',
    'SORT.Text_InProgressFirst' : 'Deschise primele',
    'SORT.Text_StandNumberAZ' : 'Număr stand (A-Z)',
    'SORT.Text_StandNumberZA' : 'Număr stand (Z-A)',
    'SORT.Text_CorridorAZ' : 'Coridor (A-Z)',
    'SORT.Text_CorridorZA' : 'Coridor (Z-A)',
    'SORT.Text_BlockAZ' : 'Bloc (A-Z)',
    'SORT.Text_BlockZA' : 'Bloc (Z-A)',
    'SORT.Text_FlagFirst' : 'Cu marcaj primele',
    'SORT.Text_FlagLast' : 'Cu marcaj ultimele',
    'SORT.Text_HallAZ' : 'Hală (A-Z)',
    'SORT.Text_HallZA' : 'Hală (Z-A)',
    'SORT.Text_StatusAZ' : 'Aprobat',
    'SORT.Text_StatusZA' : 'Neverificat',
    'STAND.Modal_Title_Search' : 'Căutare',
    'STAND.Input_Placeholder_Search' : 'Căutare',
    'STAND.Filter_Params_Exhibitor' : 'Expozant: { exhibitorName }',
    'STAND.Filter_Params_WithComments' : 'Cu comentarii',
    'STAND.Card_Hero_Hall' : 'Hală',
    'STAND.Card_Hero_Block' : 'Bloc',
    'STAND.Card_Hero_Stand' : 'Stand',
    'STAND.Card_Hero_DeliveryTime' : 'Ora livrării',
    'STAND.Modal_Title_StandPlan' : 'Desen stand',
    'STAND.Modal_Button_StandPlan' : 'Desen',
    'STAND.Card_Button_Details' : 'Detalii { icon }',
    'STAND.Modal_Title_StandPhoto' : 'Fotografie stand',
    'STAND.Modal_Button_StandPhoto' : 'Foto',
    'STAND.Modal_Button_SavePhoto' : 'Salvează fotografia',
    'STAND.Modal_Button_AddPhoto' : 'Adaugă fotografie',
    'STAND.Button_Text_Comments' : 'Comentarii',
    'STAND.Button_Text_AddComment' : 'Adaugă comentariu',
    'STAND.Modal_Title_AddComment' : 'Adaugă comentariu',
    'STAND.Modal_Title_EditComment' : 'Editează comentariu',
    'STAND.Modal_Button_AddComment' : 'Adaugă',
    'STAND.Modal_Button_SaveComment' : 'Salvează',
    'STAND.Text_NoComments' : 'Nu există încă comentarii',
    'STAND.Text_AddFile' : 'Adaugă fișier',
    'COMMENTS.Text_Uploading' : 'Se încarcă...',
    'STAND.Text_EditComment' : 'Editează',
    'STAND.Text_DeleteComment' : 'Șterge',
    'STAND.Text_CommentDraftError' : 'Schița comentariului nu este încă pregătită',
    'STAND.Block_Title_Overview' : 'Prezentare',
    'STAND.Block_Title_Materials' : 'Informații suplimentare',
    'STAND.Block_Title_Crafts' : 'Lucrări',
    'STAND.Block_ItemTitle_Hall' : 'Hală',
    'STAND.Block_ItemTitle_Block' : 'Bloc',
    'STAND.Block_ItemTitle_Stand' : 'Stand',
    'STAND.Block_ItemTitle_ProaufNumber' : 'Număr Proauf',
    'STAND.Block_ItemTitle_Jobs' : 'Sarcini',
    'STAND.Block_Item_JobCountInProgress' : '{ jobCount } în curs',
    'STAND.Block_Item_JobCountOpen' : '{ jobCount } deschise',
    'STAND.Block_Item_JobCountFinished' : '{ jobCount } finalizate',
    'STAND.Block_Button_ViewStandJobs' : 'Vezi sarcinile standului',
    'STAND.Modal_Title_StandGraphic' : 'Grafică stand',
    'STAND.Modal_Button_StandGraphic' : 'Grafică stand',
    'STAND.Modal_Title_ExtraInfo' : 'Informații extra',
    'STAND.Modal_Button_ExtraInfo' : 'Informații extra',
    'STAND.Button_Text_ViewKeys' : 'Vezi cheile',
    'STAND.Button_Text_ViewLogs' : 'Vezi jurnalele',
    'STAND.Modal_Button_AddKey' : 'Adaugă cheie',
    'STAND.Modal_Title_AddKey' : 'Adaugă cheie',
    'STAND.Modal_Title_EditKey' : 'Editează cheia',
    'STAND.Modal_Button_UpdateKey' : 'Actualizează cheia',
    'STAND.Filter_Params_Stand' : 'Stand { withFilter }',
    'STAND.Button_Text_DeleteKey' : 'Șterge',
    'STAND.Text_ModalDelete_Question' : 'Sigur doriți să ștergeți cheia { keyName }?',
    'STAND.External_Exhibition' : 'Expoziție la care nu sunteți asignat',
    'JOB.Button_Text_ViewPhoto' : 'Vezi fotografia',
    'OVERVIEW_TYPES.Label_InTotal' : 'în total',
    'OVERVIEW_TYPES.Label_Finished' : 'finalizate',
    'OVERVIEW_TYPES.Label_Open' : 'deschise',
    'OVERVIEW_TYPES.Label_Claims' : 'reclamații',
    'OVERVIEW_TYPES.Label_LastMinute' : 'last min',
    'OVERVIEW_TYPES.Label_Overdue' : 'întârziate',
    'FURNISHING.TabName_Storage' : 'Stoc',
    'FURNISHING.TabName_Refund' : 'Retururi',
    'FURNISHING.TabName_OrderLog' : 'Jurnal comenzi',
    'FURNISHING.Modal_Title_ReturnFurnishing' : 'Cantități echipament LM',
    'FURNISHING.Modal_Title_FurnishingStore' : 'Mobilier în stoc',
    'FURNISHING.Button_Text_Return' : 'Retur',
    'FURNISHING.Button_Text_ChooseFurnishing' : 'Alege mobilier',
    'FURNISHING.Modal_Title_Photo' : "Fotografie mobilier",
    'FURNISHING.Order_Type_Refund' : "Retur",
    'FURNISHING.Order_Type_Lost' : "Pierdut",
    'FURNISHING.Order_Type_Correction' : "Corecție",
    'FURNISHING.Order_Type_Order' : "Comandă",
};

export default romanian;
